var map = {
	"./404.webp": 119,
	"./career-bg.webp": 120,
	"./portfolio/forward-pay.webp": 121,
	"./portfolio/forward.webp": 122,
	"./portfolio/mozen.webp": 123,
	"./portfolio/otkritie.webp": 124,
	"./portfolio/tbi.webp": 125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 118;